/**
 * Laravel thread API — GET /api/thread/{threadId}
 *
 * Messages arrive newest-first; map with `mapThreadMessages()` before UI.
 */

/** @see mapThreadMessageRole */
export type ThreadMessageRole = 1 | 2 | 3 | 4;

/**
 * Message `type` from backend.
 * 1 text · 2 image · 3 video · 4 file · 5 voice/audio
 * 6 func_result · 7 func_call — last two hidden in widget UI.
 */
export type ThreadMessageType = 1 | 2 | 3 | 4 | 5 | 6 | 7;

/** Laravel `source_id` values used by site widget filtering */
export const THREAD_MESSAGE_SOURCE_ID = {
  /** Client-only typing placeholder — filtered if present in API */
  TYPING: 99,
  /** Welcome — widget uses settings welcome instead */
  WELCOME: 100,
  /** Internal func_call rows */
  FUNC_CALL: 101,
  /** Hidden system rows */
  INTERNAL: 102,
} as const;

export type ThreadRawMessage = {
  type: string;
  payload?: string;
  datetime?: string;
  usage?: Record<string, unknown>;
};

export type ThreadApiMessage = {
  id: number;
  thread_id: number;
  lead_follow_up_template_id: number | null;
  message_role: number;
  message: string;
  raw_message: ThreadRawMessage;
  type: number;
  like: number;
  tokens: number;
  source_id: number;
  created_at: string;
  updated_at: string;
};

export type ThreadApiCompany = {
  id: number;
  name: string;
  ai_manager_name?: string | null;
};

export type ThreadApiVisitor = {
  id: number;
  site_fingerprint_id?: string | null;
  name?: string | null;
  phone?: string | null;
};

export type ThreadApiResponse = {
  id: number;
  company_id: number;
  visitor_id: number;
  source_id: number;
  name?: string | null;
  metadata?: Record<string, unknown>;
  is_automated?: boolean;
  sender_id?: string;
  created_at: string;
  updated_at: string;
  messages: ThreadApiMessage[];
  company?: ThreadApiCompany;
  visitor?: ThreadApiVisitor;
};
